import style from './style.module.css'

// Components

import Companies from './components/Companies'
import Filter from './components/Filter'
import { useEffect, useState } from 'react'
import CompanyModal from './components/CompanyModal'
import axios from 'axios'
import useWindowWidth from '../../../hooks/useWindowWidth'
import Statistic from './components/Statistic'
import FilterHeader from './components/FilterHeader'


const API_URL = process.env.REACT_APP_API_URL

const Spotlight = () => {
  const [isCompanyModalOpen, setIsCompanyModalOpen] = useState(false)
  const [modalData, setModalData] = useState(null)
  const [companies, setCompanies] = useState([])
  const [isFilterOpen, setIsFilterOpen] = useState(false)

  const [mobileFilterButtonChoice, setMobileFilterButtonChoice] =
    useState('all')

  const isMobile = useWindowWidth() <= 768

  const handleCompanyOpen = (data) => {
    setModalData(data)
    setIsCompanyModalOpen((prev) => !prev)
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${API_URL}/enterprise`, {
          withCredentials: true,
        })

        setCompanies(data)
      } catch (error) {
        console.error(error)
      }
    }

    fetchData()
  }, [])

  return (
    <div className={style.spotlightWrapper}>
      <div className={style.container}>
        {/* For Mobile View */}
        {isMobile && <Statistic />}
        {isMobile && (
          <FilterHeader
            setIsFilterOpen={setIsFilterOpen}
            mobileFilterButtonChoice={mobileFilterButtonChoice}
            setMobileFilterButtonChoice={setMobileFilterButtonChoice}
          />
        )}

        {/* For Computer View */}
        <Filter isFilterOpen={isFilterOpen} setIsFilterOpen={setIsFilterOpen} />
        <Companies
          companies={companies}
          handleCompanyOpen={handleCompanyOpen}
        />


        {/* Company Modal */}
        {isCompanyModalOpen && (
          <CompanyModal
            data={modalData}
            handleCompanyOpen={handleCompanyOpen}
          />
        )}
      </div>
    </div>
  )
}

export default Spotlight
